import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=dca6ff12&scoped=true&"
import script from "./MatchDetail.vue?vue&type=script&lang=js&"
export * from "./MatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&id=dca6ff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca6ff12",
  null
  
)

export default component.exports